import { View } from "react-native";
import {FONT_SIZE} from "../styles";
import React from "react";
import Text from '../../common/component/CustomTextComponent';

interface ICarDetailProps {
    carObject: {
        make: string;
        model: string;
        variant: string;
        registrationNo: string;
        year: string;
    };
    fontSize?:"small" | "x-small" | "large" | "medium";
}
export const CarDetail = (props: ICarDetailProps) => {
    const carObject = props.carObject;
    const fontSize = !!props.fontSize ? props.fontSize : "medium";
    const secondaryFontSize = !!props.fontSize ? "x-small" : "small";
    return <View style={{flexDirection: "column", flexWrap: 'wrap', flex: 1}}>
        <View style={{flexDirection: "row", marginBottom: 0, flexWrap: 'wrap'}}>
            <Text fontSize={fontSize} type_of_six={"three_six"} >{!!carObject?.year ? `${carObject.year} ` : ""}</Text>
            <Text fontSize={fontSize} type_of_six={"three_six"}>{!!carObject?.make ? carObject.make : ""}</Text>
        </View>
        <View style={{flexDirection: "row", flex: 1, flexWrap: 'wrap', alignItems: "flex-end"}}>
            <Text type_of_six={"three_six"} fontSize={fontSize}>{!!carObject?.model ? `${carObject.model} ` : ""}</Text>
            <Text type_of_six={"two_six"} fontSize={secondaryFontSize} style={{maxWidth: 150}}>{!!carObject?.variant ? carObject.variant : ""}</Text>
        </View>
        {!!carObject?.registrationNo && <View style={{flexDirection: "row", flex: 1, flexWrap: 'wrap', marginTop: 3}}>
                <Text type_of_six={"two_six"} fontSize={secondaryFontSize}>{carObject?.registrationNo?.toUpperCase()}</Text>
            </View>}
    </View>
};
